// Filename: views/pagination.view
import Backbone from 'backbone';
import Handlebars from 'handlebars';
import Template from 'text-loader!../templates/pagination.htm';
import HandlebarsHelpers from '../../libs/handlebars/handlebars-helpers.ts';
import i18n  from 'l10n';

export default Backbone.View.extend({

	events: {
		'click .pagination .first a': 'gotoFirst',
		'click .pagination .previous a': 'previousResultPage',
		'click .pagination .page a': 'gotoPage',
		'click .pagination .next a': 'nextResultPage',
		'click .pagination .last a': 'gotoLast',
		'click .pagination .serverhowmany a': 'changeCount',
		'change .pagination select#sortByField': 'updateSortBy'
	},

	tagName: 'aside',

	template: _.template(Template),

	initialize: function () {
		this.collection.on('reset', this.render, this);
		//this.collection.on('change', this.render, this);
	},

	render: function () {
		var html = this.template(this.collection.info());
		this.$el.html(html);
		this.delegateEvents(this.events);

		this.$("[data-i18n]").each(function(index) {
		    $(this).text(i18n.t($(this).data("i18n")));
		});
	},

	// Events
	gotoFirst: function (e) {
		e.preventDefault();
		if(this.collection.state.firstPage != this.collection.state.currentPage){
			this.collection.getFirstPage();
		}
	},

	previousResultPage: function (e) {
		e.preventDefault();
		if(this.collection.state.currentPage > this.collection.state.firstPage){
			this.collection.getPreviousPage();
		}
	},

	gotoPage: function (e) {
		e.preventDefault();
		var page = parseInt($(e.target).text())-1;
		this.collection.getPage(page);
	},

	nextResultPage: function (e) {
		e.preventDefault();
		if(this.collection.state.currentPage < this.collection.state.lastPage){
			this.collection.getNextPage();
		}
	},

	gotoLast: function (e) {
		e.preventDefault();
		if(this.collection.state.lastPage != this.collection.state.currentPage){
			this.collection.getLastPage();
		}
	},

	changeCount: function (e) {
		e.preventDefault();
		var per = parseInt($(e.target).text());
		this.collection.setPageSize(per);
	},

	updateSortBy: function (e) {
		e.preventDefault();
		var currentSort = $('#sortByField').val();
		this.collection.setSorting(currentSort);
	}
	// End of Events

});

// Returning instantiated views can be quite useful for having "state"
